import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import useTranslation from '../hooks/useTranslations'
import { getUser } from '../services/auth/selectors'
import {
  getBasicInformation,
  getStats,
  getLastVendors,
} from '../services/home/selectors'
import { fetchHome } from 'services/home/actions'

import Greeting from '../ui/pages/dashboard/greeting'
import GeneralData from '../ui/pages/dashboard/generalData'
import Heading from '../ui/modules/heading'
import VendorsList from '../ui/modules/lists/simpleList'
import { openAddVendorModal } from 'services/modal/actions'

const Dashboard = () => {
  const t = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  const user = useSelector(getUser)

  const basicInformation = useSelector(getBasicInformation)
  const stats = useSelector(getStats)
  const lastVendors = useSelector(getLastVendors)

  const welcomeMessageKey = useMemo(() => {
    const hours = new Date().getHours()
    if (hours >= 6 && hours <= 11) return 'home:welcome-morning'
    if (hours >= 12 && hours <= 18) return 'home:welcome-afternoon'
    return 'home:welcome-evening'
  }, [])

  useEffect(() => {
    dispatch(fetchHome())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleGoToAddVendor = () => {
    dispatch(openAddVendorModal())
    history.push('/app/vendors')
  }

  return (
    <>
      <Greeting user={t(welcomeMessageKey, { user: user.first_name })} />
      {basicInformation && stats && (
        <GeneralData
          title={t('home:general-data')}
          company={basicInformation}
          vendors={stats.vendors.total}
          stats={stats}
          avatarImage={basicInformation.image_url}
          goToAddVendor={handleGoToAddVendor}
        />
      )}
      {lastVendors && lastVendors.length ? (
        <>
          <Heading
            type="vendors"
            as="h2"
            title={t('home:last-vendors')}
            number={lastVendors.length}
          />
          <VendorsList
            height={364}
            elements={lastVendors}
            isVendors={true}
            isLink={true}
          />
        </>
      ) : null}
    </>
  )
}

export default Dashboard
